
import { getMilliseconds, getOreMinuti } from './turniHelper';

export function TotaleOre(props) {

    const getTotale = () => {
        const totaleMsec = props.turni.reduce(
            (accumulator, turno) => accumulator + getMilliseconds(turno.inizio, turno.fine), 0);
        return getOreMinuti(totaleMsec);
    }

    return <div className='inEvidenza' id={props.index}>
        {getTotale()}
    </div>

}